import error from './error.gif'

export const Images = {
  error,
}
